import {GmailRegularIcon} from 'shells/icon/svg/gmail-regular-icon';
import {GoogleCalendarRegularIcon} from 'shells/icon/svg/google-calendar-regular-icon';
import {GoogleMeetRegularIcon} from 'shells/icon/svg/google-meet-regular-icon';
import {Microsoft365RegularIcon} from 'shells/icon/svg/microsoft-365-regular-icon';
import {MicrosoftOutlookRegularIcon} from 'shells/icon/svg/microsoft-outlook-regular-icon';
import {MicrosoftTeamsRegularIcon} from 'shells/icon/svg/microsoft-teams-regular-icon';
import {SquircleZoomRegularIcon} from 'shells/icon/svg/squircle-zoom-regular-icon';

import type {ConnectionNextStep} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import type {ConnectStepConfig} from './types';

export function getConnectStepConfig(
    step: ConnectionNextStep
): ConnectStepConfig | null | undefined {
    switch (step) {
        case 'GOOGLE_CALENDAR':
            return {
                title: 'Calendar',
                description:
                    'Sync your calendar, manage your availability, and let others schedule meeting with you',
                icon: GoogleCalendarRegularIcon,
                onClick: () => {
                    appHistory.replace({
                        hash: '/connect-calendar',
                        state: {modal: true},
                    });
                },
            };
        case 'GOOGLE_EMAIL':
            return {
                title: 'Email',
                description:
                    'Enable your email and sync it with Nutshell to send emails, use templates, track engagement, automate outreach, and create leads from conversations',
                icon: GmailRegularIcon,
                onClick: () => {
                    appHistory.push('/my-account/email-sending');
                },
            };
        case 'GOOGLE_EMAIL_ENABLE_SYNC':
            return {
                title: 'Email sync',
                description: 'Sync your email to create leads and automate follow-ups',
                icon: GmailRegularIcon,
                onClick: () => {
                    appHistory.push('/my-account/email-syncing');
                },
            };
        case 'GOOGLE_MEETINGS':
            return {
                title: 'Google Meet',
                description: 'Record and summarize video calls with Google Meet',
                icon: GoogleMeetRegularIcon,
                onClick: () => {
                    appHistory.push('/sales/meetings/meet');
                },
            };
        case 'MICROSOFT_CALENDAR':
            return {
                title: 'Calendar',
                description:
                    'Sync your calendar, manage your availability, and let others schedule meeting with you',
                icon: Microsoft365RegularIcon,
                onClick: () => {
                    appHistory.replace({
                        hash: '/connect-calendar',
                        state: {modal: true},
                    });
                },
            };
        case 'MICROSOFT_EMAIL':
            return {
                title: 'Email',
                description:
                    'Enable your email and sync it with Nutshell to send emails, use templates, track engagement, automate outreach, and create leads from conversations',
                icon: MicrosoftOutlookRegularIcon,
                onClick: () => {
                    appHistory.push('/my-account/email-sending');
                },
            };
        case 'MICROSOFT_EMAIL_ENABLE_SYNC':
            return {
                title: 'Email sync',
                description: 'Sync your email to create leads and automate follow-ups',
                icon: MicrosoftOutlookRegularIcon,
                onClick: () => {
                    appHistory.push('/my-account/email-syncing');
                },
            };
        case 'MICROSOFT_MEETINGS':
            return {
                title: 'Microsoft Teams',
                description: 'Record and summarize video calls with Microsoft Teams',
                icon: MicrosoftTeamsRegularIcon,
                onClick: () => {
                    appHistory.push('/sales/meetings/teams');
                },
            };
        case 'ZOOM_MEETINGS':
            return {
                title: 'Zoom',
                description: 'Record and summarize video calls with Zoom',
                icon: SquircleZoomRegularIcon,
                onClick: () => {
                    appHistory.push('/sales/meetings/zoom');
                },
            };
    }
}
